import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2 mb-3" }
const _hoisted_2 = {
  key: 0,
  class: "text-red-800 text-sm mb-2"
}
const _hoisted_3 = {
  key: 1,
  class: "p-3 bg-gray-50 rounded-lg text-center text-sm text-gray-600"
}
const _hoisted_4 = {
  key: 2,
  class: "p-3 bg-gray-50 rounded-lg text-center text-sm text-gray-600"
}
const _hoisted_5 = {
  key: 3,
  class: "p-3 bg-gray-50 rounded-lg text-center text-sm text-gray-600"
}
const _hoisted_6 = {
  key: 4,
  class: "flex flex-col gap-2 overflow-y-auto pr-1 max-h-96"
}
const _hoisted_7 = ["disabled", "title", "onClick"]
const _hoisted_8 = { class: "text-lg font-semibold" }
const _hoisted_9 = { class: "text-xs" }
const _hoisted_10 = {
  key: 5,
  class: "mt-3 text-sm text-gray-700 text-center"
}

import { computed, inject, ref, watch } from "vue";
import store from "@/store";
import helpers from "@/helpers";
import { getThemeColor } from "@/branding";
import {
  FormValidatedValuesKey,
  FormValidatedUpdateKey,
  FormValidatedErrorsKey,
} from "../../types/inject";
import { HorarioDisponivel } from "@/types/janela_agendamento";


export default /*#__PURE__*/_defineComponent({
  __name: 'HorariosDisponiveis',
  props: {
  setorField: {
    type: String,
    default: "setor",
  },
  dataField: {
    type: String,
    default: "data",
  },
  ignorarUkey: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;



const theme = getThemeColor();

const values = inject(FormValidatedValuesKey, {});
const errors = inject(FormValidatedErrorsKey, {});
const onUpdate = inject(FormValidatedUpdateKey);

const erroHorario = computed(() => String(errors.horario ?? ""));

const carregando = ref(false);
const horarios = ref<HorarioDisponivel[]>([]);

const setorSelecionado = computed(() => String(values[props.setorField] ?? ""));
const operacaoSelecionada = computed(() => String(values.operacao ?? ""));
const horarioSelecionado = computed(() => String(values.horario ?? ""));

const dataSelecionada = computed(() => {
  const valor = values[props.dataField];
  if (!valor) {
    return "";
  }
  if (valor instanceof Date) {
    return helpers.formatDate(valor, "yyyy-MM-dd");
  }
  return String(valor).substring(0, 10);
});

const chaveConsulta = computed(
  () => `${setorSelecionado.value}|${operacaoSelecionada.value}|${dataSelecionada.value}`
);

const limparHorario = () => {
  if (typeof onUpdate == "function" && horarioSelecionado.value) {
    onUpdate({ horario: "" });
  }
};

const carregarHorarios = async () => {
  if (!setorSelecionado.value || !operacaoSelecionada.value || !dataSelecionada.value) {
    horarios.value = [];
    return;
  }

  carregando.value = true;
  try {
    const resposta = await store.dispatch("getHorariosDisponiveis", {
      setor_ukey: setorSelecionado.value,
      data: dataSelecionada.value,
      operacao: operacaoSelecionada.value,
      ignorar_ukey: props.ignorarUkey,
    });
    horarios.value = resposta?.horarios ?? [];
  } catch (err) {
    horarios.value = [];
  } finally {
    carregando.value = false;
  }
};

watch(
  chaveConsulta,
  async (nova, antiga) => {
    if (typeof antiga != "undefined" && nova != antiga) {
      limparHorario();
    }
    await carregarHorarios();
  },
  { immediate: true }
);

const selecionarHorario = (item: HorarioDisponivel) => {
  if (item.status != "aberto") {
    return;
  }
  typeof onUpdate == "function" && onUpdate({ horario: item.horario });
};

const classesDoHorario = (item: HorarioDisponivel) => {
  const base =
    "w-full flex items-center justify-between rounded-lg border-2 py-2 px-3 transition-colors duration-150 focus:outline-none";

  if (item.horario == horarioSelecionado.value) {
    return `${base} bg-${theme}-800 border-${theme}-800 text-white`;
  }

  if (item.status == "lotado") {
    return `${base} bg-gray-200 border-gray-300 text-gray-400 cursor-not-allowed line-through`;
  }

  if (item.status == "bloqueado") {
    return `${base} bg-red-100 border-red-200 text-red-700 cursor-not-allowed`;
  }

  if (item.status == "encerrado") {
    return `${base} bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed`;
  }

  return `${base} bg-white border-gray-300 text-gray-800 hover:bg-gray-100 cursor-pointer`;
};

const legendaDoHorario = (item: HorarioDisponivel) => {
  if (item.status == "lotado") {
    return "Sem vagas";
  }
  if (item.status == "bloqueado") {
    return "Bloqueado";
  }
  if (item.status == "encerrado") {
    return "Horário encerrado";
  }
  const vagas = Number(item.disponivel ?? 0);
  return `${vagas} ${vagas == 1 ? "vaga" : "vagas"}`;
};

const tituloDoHorario = (item: HorarioDisponivel) => {
  if (item.status == "bloqueado" && item.observacao) {
    return `Bloqueado: ${item.observacao}`;
  }
  if (item.status == "bloqueado") {
    return "Horário bloqueado";
  }
  if (item.status == "lotado") {
    return "Sem vagas neste horário";
  }
  if (item.status == "encerrado") {
    return "Este horário já passou";
  }
  return `Selecionar ${item.horario}`;
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full h-full p-3 bg-white rounded-lg border flex flex-col", _unref(erroHorario) ? 'border-red-800' : 'border-gray-200'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_font_awesome_icon, {
        icon: "clock",
        class: _normalizeClass(`text-${_unref(theme)}-900`)
      }, null, 8, ["class"]),
      _createElementVNode("span", {
        class: _normalizeClass(["text-base font-semibold", `text-${_unref(theme)}-900`])
      }, " Horários disponíveis ", 2)
    ]),
    (_unref(erroHorario))
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(erroHorario)), 1))
      : _createCommentVNode("", true),
    (!_unref(setorSelecionado) || !_unref(operacaoSelecionada))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Selecione o setor e a operação para ver os horários. "))
      : (carregando.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_font_awesome_icon, {
              icon: "sync-alt",
              spin: "",
              class: "mr-2"
            }),
            _createTextVNode(" Carregando horários... ")
          ]))
        : (horarios.value.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Nenhum horário disponível para esta data. "))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(horarios.value, (item) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: item.horario,
                  type: "button",
                  disabled: item.status != 'aberto',
                  title: tituloDoHorario(item),
                  class: _normalizeClass(classesDoHorario(item)),
                  onClick: ($event: any) => (selecionarHorario(item))
                }, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(item.horario), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(legendaDoHorario(item)), 1)
                ], 10, _hoisted_7))
              }), 128))
            ])),
    (_unref(horarioSelecionado))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createTextVNode(" Horário selecionado: "),
          _createElementVNode("b", null, _toDisplayString(_unref(horarioSelecionado)), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})